<template>
  <div class="mobile">
    <Banner></Banner>
    <div class="mobileContent">
      <mobileCategorizedProductDisplay></mobileCategorizedProductDisplay>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import Banner from '@/components/banner/mobile.vue';
import mobileCategorizedProductDisplay from '@/components/categorizedProductDisplay/mobileCategorizedProductDisplay.vue';

const { t } = useI18n();
</script>

<style lang="less" scoped>
.mobile {
  .mobileContent {
    padding: 0.1rem;
    background-color: #f4f4f4;
  }
}
</style>
